webpackJsonp([104101334113578],{

/***/ 74:
/***/ (function(module, exports) {

	"use strict";
	
	exports = module.exports = {
	    PageSize: 10,
	    SlackAPI: "https://f09hhgz7j5.execute-api.us-west-2.amazonaws.com/Slack/SlackBlogNotification",
	    MyDomain: "https://www.smilingleo.net"
	};

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _paginateLink = __webpack_require__(210);
	
	var _paginateLink2 = _interopRequireDefault(_paginateLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _require = __webpack_require__(74),
	    PageSize = _require.PageSize;
	
	var formatDate = function formatDate(dateStr) {
	  var date = new Date(Date.parse(dateStr));
	  return date.toLocaleDateString() + '  ' + date.toLocaleTimeString();
	};
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	
	  // for pagination
	  var group = pathContext.group,
	      index = pathContext.index,
	      first = pathContext.first,
	      last = pathContext.last;
	
	  var prevUrl = index - 1 == 1 ? "" : (index - 1).toString();
	  var nextUrl = (index + 1).toString();
	  var total = data.allMarkdownRemark.edges.length;
	
	  var posts = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'posts' },
	      group.map(function (_ref2, pIdx) {
	        var post = _ref2.node;
	        var frontmatter = post.frontmatter;
	
	        return _react2.default.createElement(
	          'div',
	          { key: 'post_' + pIdx },
	          _react2.default.createElement(
	            'h2',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: frontmatter.path },
	              frontmatter.title
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            formatDate(frontmatter.date)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            frontmatter.excerpt
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            post.frontmatter.tags.map(function (tag, tagIdx) {
	              return _react2.default.createElement(
	                'li',
	                { key: 'tag_' + pIdx + '_' + tagIdx },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/tags/' + tag },
	                  tag
	                )
	              );
	            })
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'paginatation' },
	      _react2.default.createElement(
	        'div',
	        { className: 'prevLink' },
	        _react2.default.createElement(_paginateLink2.default, { tag: first, url: prevUrl, text: 'Prev Page' })
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        index,
	        ' of ',
	        Math.ceil(total / PageSize)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'nextLink' },
	        _react2.default.createElement(_paginateLink2.default, { tag: last, url: nextUrl, text: 'Next Page' })
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = IndexPage;

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaginateLink = function PaginateLink(_ref) {
	    var tag = _ref.tag,
	        url = _ref.url,
	        text = _ref.text;
	
	    if (!tag) {
	        return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: url },
	                text
	            )
	        );
	    } else {
	        return _react2.default.createElement(
	            'span',
	            null,
	            text
	        );
	    }
	};
	
	exports.default = PaginateLink;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-index-js-9cf21badbbd65a1304ea.js